import React from "react";
import { CONNECTOME_URL, CURRENT_YEAR } from "../../utils/constants";
import Typography from "../Typography/Typography";
import { fontWeight } from "../../utils/constants/UI";
import { GREY } from "../../utils/constants/colors";
import Anchor from "../Anchor/Anchor";
import { styles } from "./styles";

const RightsTag = () => {
  const classes = styles();
  return (
    <>
      <Typography
        size={"xs"}
        color={GREY.TERTIARY}
        fontWeight={fontWeight.REGULAR}
        label={` ©${CURRENT_YEAR}`}
      />

      <Anchor
        href={CONNECTOME_URL}
        target="_blank"
        className={classes.hovering}
      >
        <div className={classes.Padding}>
          {" "}
          <Typography
            size={"xs"}
            color={GREY.TERTIARY}
            fontWeight={fontWeight.REGULAR}
            label={" Connectome Inc."}
          />
        </div>
      </Anchor>
      <Typography
        size={"xs"}
        color={GREY.TERTIARY}
        fontWeight={fontWeight.REGULAR}
        label={" All Rights Reserved."}
      />
    </>
  );
};

export default RightsTag;
